export type CustomerInfo = {
    customerAccountDetailID: string;
    customerAccountName: string;
    customerAccountNumber: string;
    warehouseCode: string;
    customerEmail: string;
    customerPhone: string;
    customerAddresses: {
        customerAddressPkey: string;
        addressID: string;
        addressLine1: string;
        addressLine2: string;
        addressLine3: string;
        city: string;
        state: string;
        country: string;
        postalCode: string;
        stateID: string;
        countryID: string;
    };
    prohibitSales: string;
    creditcode: string;
    statusCode: string;
}
export type CustomerInfoState = {
    data: CustomerInfo[];
    loading: boolean;
    error: string | null;
}

export const initialState: CustomerInfoState = {
    data: [],
    loading: false,
    error: null,
};
export type CustomerInfoServiceOperators = {
    customerInfo: CustomerInfo[];
    fetchAllCustomerInfo: () => void;
};